import en from '@/messages/en'
import fr from '@/messages/fr'

export default {
  en,
  fr
}
